export default __webpack_public_path__ + "static/media/addfile.d114f68e.svg";